import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';
import { FormSeoMetaData } from '@sb-tools/typescript/models/form-seo-meta-data.model';
import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';
import { SeoMetaData } from '@sb-tools/typescript/models/seo-meta-data.model';

type tagType = 'title' | 'description' | 'image' | 'locale' | 'type' | 'url';

@Injectable({ providedIn: 'root' })
export class SEOService {
    constructor(
        private httpClient: HttpClient,
        private meta: Meta,
        private title: Title,
    ) {}

    updateMetaTag(tagName: tagType, tagContent: string): void {
        this.meta.updateTag({ name: tagName, content: tagContent });
    }

    updateTitle(title: string): void {
        this.title.setTitle(title);
    }

    setSEOData(data: FormSeoMetaData, url: string): void {
        this.title.setTitle(data.title);

        this.meta.updateTag({ name: 'title', content: data.title });
        this.meta.updateTag({ name: 'og:title', content: data.title });
        this.meta.updateTag({ name: 'og:image:alt', content: data.title });
        this.meta.updateTag({ name: 'twitter:title', content: data.title });
        this.meta.updateTag({ name: 'twitter:image:alt', content: data.title });

        this.meta.updateTag({ name: 'description', content: data.description });
        this.meta.updateTag({ name: 'og:description', content: data.description });
        this.meta.updateTag({ name: 'twitter:description', content: data.description });

        this.meta.updateTag({ name: 'image', content: data.image });
        this.meta.updateTag({ name: 'og:image', content: data.image });
        this.meta.updateTag({ name: 'twitter:image', content: data.image });

        this.meta.updateTag({ name: 'url', content: url });
        this.meta.updateTag({ name: 'og:url', content: url });
        this.meta.updateTag({ name: 'twitter:url', content: url });

        switch (data.language) {
            case LocalizationLanguage.norwegian:
                this.meta.updateTag({ name: 'locale', content: 'nb_NO' });
                this.meta.updateTag({ name: 'og:locale', content: 'nb_NO' });
                this.meta.updateTag({ name: 'og:locale:alternate', content: 'nn_NO' });
                this.meta.updateTag({ name: 'og:locale:alternate', content: 'en_US' });
                break;
            case LocalizationLanguage.swedish:
                this.meta.updateTag({ name: 'locale', content: 'sv_SE' });
                this.meta.updateTag({ name: 'og:locale', content: 'sv_SE' });
                this.meta.updateTag({ name: 'og:locale:alternate', content: 'en_US' });
                break;
            case LocalizationLanguage.danish:
                this.meta.updateTag({ name: 'locale', content: 'da_DK' });
                this.meta.updateTag({ name: 'og:locale', content: 'da_DK' });
                this.meta.updateTag({ name: 'og:locale:alternate', content: 'en_US' });
                break;
            case LocalizationLanguage.finnish:
                this.meta.updateTag({ name: 'locale', content: 'fi_FI' });
                this.meta.updateTag({ name: 'og:locale', content: 'fi_FI' });
                this.meta.updateTag({ name: 'og:locale:alternate', content: 'sv_FI' });
                this.meta.updateTag({ name: 'og:locale:alternate', content: 'en_US' });
                break;
            default:
                this.meta.updateTag({ name: 'locale', content: 'en_US' });
                this.meta.updateTag({ name: 'og:locale', content: 'en_US' });
        }
    }

    getFAQSEOData(data: any): Observable<SeoMetaData> {
        return this.httpClient.get<SeoMetaData>(environment.apiFaqUrl + 'metadata', {
            params: data,
        });
    }

    getFormSEOData(formName: string = null): Observable<FormSeoMetaData> {
        return this.httpClient.get<FormSeoMetaData>(environment.apiFormUrl + 'metadata', {
            params: { formName },
        });
    }
}
